import React from 'react';
import {TouchableOpacity, View, Platform} from 'react-native';

import Screen from '../../../../../shared/components/screen';

import {useStyles} from '../../../../../shared/hooks/styles';
import {Button} from '../../../../../shared/components/button';
import {ApplicationsListItem} from './listItem';
import {ApplicationsProps} from '../../../common/applications/model';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {Text} from '../../../../../shared/components/text';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({onLoadMore, onPressItem, applications, allShown, onPressShowFilter}: ApplicationsProps) => {
  const styles = useStyles(({theme}) => ({
    container: {
      marginTop: 16,
      paddingHorizontal: 16,
      paddingBottom: theme.screen.bottomOffset,
      flexDirection: 'column',
      alignItems: 'stretch',
    },
    loadMore: {
      paddingTop: 25,
    },
    item: {
      marginBottom: 16,
    },
    buttonWrapper: {
      marginBottom: 20,
    },
    loadMoreButton: {
      width: 203,
      alignSelf: 'center',
    },
    noData: {
      ...theme.fonts.bodySmallLight,
      color: theme.privilegeNoData.color,
      textAlign: 'center',
    },
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic' onEndReached={!allShown ? onLoadMore : undefined}>
        <LoadableContent loading={!applications}>
          <View style={styles.container}>
            {!!applications && !applications.length ? <Text style={styles.noData}>Заявления отсутствуют</Text> : null}
            {applications?.length ? (
              <View style={styles.buttonWrapper}>
                <Button
                  id='profile-applications-filter'
                  onPress={onPressShowFilter}
                  block={true}
                  iconProps={{width: 20, height: 20}}
                  text='Фильтр'
                  type='secondary'
                />
              </View>
            ) : null}
            {applications
              ? applications.map((application, i) => (
                  <TouchableOpacity
                    testID={`application-list-item-button-${i}-id`}
                    onPress={() => onPressItem(application)}
                    key={i}>
                    <ApplicationsListItem style={styles.item} application={application} />
                  </TouchableOpacity>
                ))
              : null}
            {!allShown && Platform.OS === 'web' ? (
              <Button
                id='profile-applications-more'
                style={styles.loadMoreButton}
                onPress={onLoadMore}
                text='Показать еще'
                type='secondary'
              />
            ) : null}
          </View>
        </LoadableContent>
      </CustomScrollView>
    </Screen>
  );
};
